
import { useCheckPermissions } from "@/shared";
import SaveSolicitudesIngresos from "../../shared/saveSolicitudesIngresos";
import { PermissionsEnum } from "@/auth/interfaces";


const CrearSolicitudIngresoPage=()=>{
  
 useCheckPermissions(PermissionsEnum.api_add_solicitudingreso)
 return <SaveSolicitudesIngresos title="Crear Solicitud de Compra"/>
}
export default CrearSolicitudIngresoPage;